import axiosInstance from './axios.instance';

class LocationService {

    async getPlacesAutocomplete(input) {
        try {
            const response = await axiosInstance.get(`/places/autocomplete?input=${input}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching places autocomplete:", error);
            throw error;
        }
    }

    async getAddress(input) {
        try {
            const response = await axiosInstance.get(`/places/address?input=${input}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching address:", error);
            throw error;
        }
    }

    async getGeocode(address) {
        try {
            const response = await axiosInstance.get(`/places/geocode?address=${encodeURIComponent(address)}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching geocode:", error);
            throw error;
        }
    }

    async getPlaceDetails(placeId) {
        try {
            const response = await axiosInstance.get(`/places/details?placeId=${placeId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching place details:", error);
            throw error;
        }
    }
}

export default new LocationService();